import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';



export class UtilMasks {

  constructor() { }

  static cpf = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

  static idLaudo = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]; // 14 Dígitos nessa máscara ...

  static cnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

  static cep = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];

  static placa = [/[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /\d/, /[A-Ja-j0-9]/, /\d/, /\d/];

  static dataBr = [/[\d]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  //static dataBr = createAutoCorrectedDatePipe('dd/mm/yyyy');

  static renavam = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  static mes = [/\d/, /\d/];

  static ano = [/\d/, /\d/, /\d/, /\d/];

  static hora = [/[0-2]/, /[0-4]/,':', /[0-5]/, /[0-9]/,];

  static cvv = [/\d/, /\d/, /\d/, /\d/];

  static mesAno = [/[0-1]/, /[0-9]/, '/', /[1-9]/, /[0-9]/];

  static creditCard = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];

  /*static placa(userInput) {
    let isInteger = /[0-9]/;
    if(userInput.length>3 && isInteger.test(userInput[4])){
      return [/[A-z]/,/[A-z]/,/[A-z]/, /\d/,/\d/,/[A-z]/,/\d/];
    } else {
      return [/[A-z]/,/[A-z]/,/[A-z]/, /\d/,/[A-z]/,/\d/,/\d/];
    }
  }*/

  static chassi(){
    let chassiMask = [];
    for( let i=0; i<17; i++ )
      chassiMask.push(/[A-Za-z0-9]/)
    return chassiMask;
  }

  static horario(date) {
    let data = date.substring(0,1);
    if(data == 2) { return [/[0-2]/, /[0-3]/,':', /[0-5]/, /[0-9]/,]; }
    if(data == 0 || data == 1) { return [/[0-2]/, /[0-9]/,':', /[0-5]/, /[0-9]/,]; }
  }


  static telefone(userInput) {
    const input = (userInput || '').match(/\d/g);
    return (input === null || input.join('').length <= 10)
    ? ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    : ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  static documento(userInput) {
    const input = (userInput || '').match(/\d/g);
    return (input === null || input.join('').length <= 11) ? UtilMasks.cpf : UtilMasks.cnpj;
  }

  static moeda = createNumberMask({
    prefix: 'R$ ',
    thousandsSeparatorSymbol: '.',
    decimalSymbol: ',',
    allowDecimal: true,
  });

  static decimal = createNumberMask({
    prefix: '',
    thousandsSeparatorSymbol: '.',
    decimalSymbol: ',',
    allowDecimal: true,
  });

  static number = createNumberMask({
    prefix: '',
    thousandsSeparatorSymbol: '',
    decimalSymbol: '',
    allowDecimal: true,
  });

  static data = {
    mask: [/[\d]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('dd/mm/yyyy'),
    guide: false,
    keepCharPositions: true
};

}
